import type { InFieldUser, InFieldUserPreferences } from '@cognite/apm-client';

import type { UserPreferencesServiceDependencies } from '../cdm-use-upsert-user-preferences.context';

import {
  getUserPreferencesFromUser,
  type UserPreferencesUpdate,
} from './user-preference';

/**
 * Upserts user preferences based on the provided props and current user.
 * Returns undefined if user is null or if no preferences are generated.
 *
 * @param userPreferenceUpdate - The preference type and data to update
 * @param user - The current user
 * @param userPreferencesService - The service to upsert preferences
 * @returns The updated preferences or undefined
 */
export const upsertUserPreferences = async (
  userPreferencesUpdate: UserPreferencesUpdate,
  user: InFieldUser,
  upsertFunction: UserPreferencesServiceDependencies['upsert']
): Promise<InFieldUserPreferences | undefined> => {
  const newPreferences = getUserPreferencesFromUser(
    userPreferencesUpdate,
    user
  );

  if (!newPreferences) return;

  const response = await upsertFunction([newPreferences]);
  return response?.data?.items?.[0];
};
